import { RouteConfig } from 'vue-router';
import Availability from '../../apps/availability/Availability.vue';
import { requireProvider } from '@/router/guards/authGuards';
import { checkSitterOnboarding } from '@/router/guards/completionGuards';
import combineGuards from '@/router/guards/helpers';

const availabilityRoutes: RouteConfig[] = [
  {
    path: '/availability',
    name: 'Availability',
    component: Availability,
    beforeEnter: combineGuards([requireProvider, checkSitterOnboarding]),
  },
];

export default availabilityRoutes;
